import { Fragment, useEffect, useRef, useState } from 'react'
import { Button, Col, Container, Form, FormGroup, Input, Label, Row } from 'reactstrap'
import axios from 'axios';
import { baseURL, getPublicS3Url } from '../../../../../Services/api/baseURL';
import Swal from 'sweetalert2';
import { useNavigate, useParams } from 'react-router';
import { FiTrash, FiPlus } from 'react-icons/fi';
import { H3 } from '../../../../../AbstractElements';
import PositiveNumberInput from '../../../../Common/PositiveNumberInput';


const CreateProduct = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [categories, setCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fileInputRef = useRef(null);

    const [productDetails, setProductDetails] = useState([{ key: '', value: '' }]);
    const initialFormState = {
  name: "",
  category: "",
  description: "",
  sellingType: "",
  price: "",
  originalPrice: "",
  stock: "",
  pricePerKg: "",
  originalPricePerKg: "",
  weights: [],
  newWeight: "",
  newStock: "",
  productDetails: [],
  images: [],
  imagePreview: [],
  imageNames: []
};
    const [formData, setFormData] = useState(initialFormState)
    //     {
    //     name: "",
    //     category: "",
    //     description: "",
    //     sellingType: "",   // "unit" | "weight"

    //     // --- Unit product fields ---
    //     price: "",
    //     originalPrice: "",
    //     stock: "",

    //     // --- Weight product fields ---
    //     pricePerKg: "",
    //     originalPricePerKg: "",
    //     weights: [],       // e.g. [1, 2, 5] kg options
    //     newWeight: "",     // temporary input field
    //     newStock: "",      // temporary input field

    //     // --- Extra details ---
    //     productDetails: [],   // [{ key: "", value: "" }]

    //     // --- Images ---
    //     images: [],           // final S3 keys
    //     imagePreview: []      // local preview URLs
    // });
    const handleImageUpload = (e) => {
        const files = Array.from(e.target.files);

        if (files.length > 5) {
            Swal.fire({
                icon: 'warning',
                title: 'Limit Exceeded',
                text: 'You can upload a maximum of 5 images.',
            });
            return;
        }

        const previews = files.map((file) => URL.createObjectURL(file));

        setFormData((prev) => ({
            ...prev,
            image: files,
            imagePreview: previews,
            imageNames: files.map(file => file.name),
        }));
    };
    const handleAddDetail = () => {
        setProductDetails((prev) => [...prev, { key: '', value: '' }]);
    };
    const handleChange = (index, field, value) => {
        setProductDetails((prev) =>
            prev.map((detail, i) =>
                i === index ? { ...detail, [field]: value } : detail
            )
        );
    };
    const handleRemoveImage = (index) => {
        setFormData((prev) => ({
            ...prev,
            imagePreview: prev.imagePreview.filter((_, i) => i !== index),
        }));
    };

    const handleDeleteDetail = (index) => {
        setProductDetails((prev) => prev.filter((_, i) => i !== index));
    };

const handleSubmit = async (e) => {
  e.preventDefault();

  // Check if at least one image is selected
  if (!formData.imagePreview || formData.imagePreview.length === 0) {
    Swal.fire({ 
      icon: "warning", 
      title: "Missing Images", 
      text: "Please select at least one product image." 
    });
    return;
  }

  // Basic validations
  if (!formData.description?.trim()) {
    Swal.fire({ icon: "warning", title: "Missing Description", text: "Product description is required." });
    return;
  }

  const flatDetails = productDetails.filter(d => d.key?.trim() && d.value?.trim());
  if (flatDetails.length === 0) {
    Swal.fire({ icon: "warning", title: "Missing Product Details", text: "Please add at least one product detail (key + value)." });
    return;
  }

  // Convert details array -> key-value object
  const detailObject = {};
  flatDetails.forEach(d => { detailObject[d.key] = d.value; });

  // Build FormData
  const data = new FormData();
  data.append("name", formData.name);
  data.append("category", formData.category);
  data.append("description", formData.description.trim());
  data.append("sellingType", formData.sellingType);
  data.append("productDetails", JSON.stringify(detailObject));

  // Unit selling type
  if (formData.sellingType === "unit") {
    data.append("price", formData.price || 0);
    if (formData.originalPrice) data.append("originalPrice", formData.originalPrice);
    data.append("stock", formData.stock || 0);
  }


if (formData.sellingType == "weight") {
  const pricePerKg = formData.pricePerKg ? Number(formData.pricePerKg) : 0;
  const originalPricePerKg = formData.originalPricePerKg ? Number(formData.originalPricePerKg) : undefined;

  // Prefer the explicit weights array added by "Add".
  // If empty, but user typed newWeight/newStock, use those as a single option.
  let rawWeights = Array.isArray(formData.weights) ? formData.weights : [];
  if (rawWeights.length === 0 && formData.newWeight && formData.newStock) {
    rawWeights = [{ weight: Number(formData.newWeight), stock: Number(formData.newStock) }];
  }

  const options = (rawWeights || []).map(w => ({
    weight: Number(w.weight),
    stock: Number(w.stock || 0),
    price: pricePerKg ? Number(pricePerKg) * Number(w.weight) : undefined
  })).filter(o => !Number.isNaN(o.weight) && o.weight > 0);

  if (!pricePerKg || options.length === 0) {
    Swal.fire({
      icon: "warning",
      title: "Missing Weight Data",
      text: "Please enter Price Per Kg and add at least one weight option (kg + stock).",
    });
    return;
  }

  const weightDetails = { pricePerKg, originalPricePerKg, options };
  data.append("weightDetails", JSON.stringify(weightDetails));
}


  // Images: prefer newly uploaded File objects (formData.images).
  // If none, send existing S3 keys (non-blob URLs) via existingImages.
  console.log(formData,'formData');
  if (formData?.image?.length > 0) {
    
    formData.image.forEach(file => {
      data.append("images", file);
    });
  } else {
    // filter out any local blob: URLs — keep only S3 keys (strings not starting with blob:)
    const existing = (formData.imagePreview || []).filter(p => typeof p === "string" && !p.startsWith("blob:"));
    if (existing.length > 0) {
      data.append("existingImages", JSON.stringify(existing));
    }
  }

  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const endpoint = id ? `${baseURL}/api/product/${id}` : `${baseURL}/api/product`;
    const method = id ? "put" : "post";

    await axios[method](endpoint, data, {
      headers: { Authorization: `Bearer ${token}` },
    });

    Swal.fire({
      icon: "success",
      title: id ? "Product Updated Successfully!" : "Product Added Successfully!",
      text: id ? `${formData.name} has been updated.` : `${formData.name} has been added to your catalouge.`,
      confirmButtonText: "OK",
    });
    navigate(-1);
  } catch (error) {
    console.error("Submit Error:", error);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: error.response?.data?.error || "Failed to submit product",
    });
  }
};

    const handleReset = () => {
        setFormData(initialFormState);
        setProductDetails([{ key: "", value: "" }]);


  if (fileInputRef.current) {
    // clear native file input
    fileInputRef.current.value = "";
  }
    };
    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const token = localStorage.getItem("token");

                // Always fetch categories
                const categoriesRes = await axios.get(`${baseURL}/api/category`);
                setCategories(categoriesRes.data || []);

                // Fetch product only if editing
                if (id) {
                    const res = await axios.get(`${baseURL}/api/product/${id}`, {
                        headers: { Authorization: `Bearer ${token}` },
                    });
                    const product = res.data?.product;

                    // ✅ Build form data
                    setFormData({
                        name: product?.name || "",
                        category: product?.category?._id || "",
                        description: product?.description || "",
                        sellingType: product?.sellingType || "",

                        // Unit product fields
                        price: product?.unitDetails?.price || "",
                        originalPrice: product?.unitDetails?.originalPrice || "",
                        stock: product?.unitDetails?.stock || "",

                        // Weight product fields
                        pricePerKg: product?.weightDetails?.pricePerKg || "",
                        originalPricePerKg: product?.weightDetails?.originalPricePerKg || "",
                        weights: product?.weightDetails?.options || [],
                        newWeight: "",
                        newStock: "",

                        // Images
                        image: [],
                        imagePreview: product?.images || [],

                        // Extra details
                        productDetails: product?.productDetails || [],
                    });

                    // ✅ Convert productDetails object → array for editing
                    if (product?.productDetails) {
                        const detailsArray = Object.entries(product.productDetails).map(
                            ([key, value]) => ({ key, value })
                        );
                        setProductDetails(detailsArray.length ? detailsArray : [{ key: "", value: "" }]);
                    }
                }
            } catch (error) {
                console.error("Fetch Error:", error);
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: error.response?.data?.message || "Failed to load data",
                });
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [id]);
    console.log(formData)
    return (
        <Fragment>
            <Form onSubmit={handleSubmit} style={{ marginInline: '24px' }}>
                <Container fluid={true}>
                    <div className='page-title'>
                        <Row>
                            <Col xs='6'>
                                <H3>{id ? "Update Product" : "Add a New Product"}</H3>
                            </Col>
                            <Col xs='6'>
                                <div className='text-right'>
                                    {!id && <Button onClick={() => handleReset()} className='me-3 reset_btn'>Reset All</Button>}
                                    <Button className='save_btn' type='submit' >{!isLoading && (id ? "Update Details" : "Save Details")}
                                        {isLoading && (id ? "Updating..." : "Saving...")}
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
                <Row >
                    {/* Category */}
                    <Col md={6}>
                        <FormGroup>
                            <Label>
                                Category <span className="text-danger">*</span>
                            </Label>
                            <Input
                                type="select"
                                value={formData.category}
                                onChange={(e) =>
                                    setFormData((prev) => ({
                                        ...prev,
                                        category: e.target.value,
                                    }))
                                }
                                required
                            >
                                <option value="">Select Category</option>
                                {categories.map((cat) => (
                                    <option key={cat._id} value={cat._id}>
                                        {cat.name}
                                    </option>
                                ))}
                            </Input>
                        </FormGroup>
                    </Col>

                    {/* Product Name */}
                    <Col md={6}>
                        <FormGroup>
                            <Label>
                                Product Name <span className="text-danger">*</span>
                            </Label>
                            <Input
                                type="text"
                                value={formData.name}
                                onChange={(e) =>
                                    setFormData((prev) => ({
                                        ...prev,
                                        name: e.target.value,
                                    }))
                                }
                                required
                            />
                        </FormGroup>
                    </Col>
                </Row>

                {/* Selling Type */}
                <FormGroup>
                    <Label>
                        Selling Type <span className="text-danger">*</span>
                    </Label>
                    <Input
                        type="select"
                        value={formData.sellingType}
                        onChange={(e) =>
                            setFormData((prev) => ({
                                ...prev,
                                sellingType: e.target.value,
                                // reset fields when switching
                                price: "",
                                originalPrice: "",
                                stock: "",
                                pricePerKg: "",
                                originalPricePerKg: "",
                                weights: [],
                                newWeight: "",
                            }))
                        }
                        required
                    >
                        <option value="">Select Type</option>
                        <option value="unit">Per Unit</option>
                        <option value="weight">By Weight (kg)</option>
                    </Input>
                </FormGroup>

                {/* ================= UNIT PRODUCT FIELDS ================= */}
                {formData.sellingType === "unit" && (
                    <>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>
                                        Price <span className="text-danger">*</span>
                                    </Label>
                                    <PositiveNumberInput
                                        value={formData.price}
                                        onChange={(e) =>
                                            setFormData((prev) => ({
                                                ...prev,
                                                price: e.target.value,
                                            }))
                                        }
                                        placeholder="Enter price"
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Original Price</Label>
                                    <PositiveNumberInput
                                        value={formData.originalPrice}
                                        onChange={(e) =>
                                            setFormData((prev) => ({
                                                ...prev,
                                                originalPrice: e.target.value,
                                            }))
                                        }
                                        placeholder="Enter original price"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <FormGroup>
                            <Label>
                                Stock <span className="text-danger">*</span>
                            </Label>
                            <PositiveNumberInput
                                value={formData.stock}
                                onChange={(e) =>
                                    setFormData((prev) => ({
                                        ...prev,
                                        stock: e.target.value,
                                    }))
                                }
                                placeholder="Enter stock quantity"
                                required
                            />
                        </FormGroup>
                    </>
                )}

                {/* ================= WEIGHT PRODUCT FIELDS ================= */}
                {formData.sellingType === "weight" && (
                    <>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>
                                        Price Per Kg <span className="text-danger">*</span>
                                    </Label>
                                    <PositiveNumberInput
                                        value={formData.pricePerKg}
                                        onChange={(e) =>
                                            setFormData((prev) => ({
                                                ...prev,
                                                pricePerKg: e.target.value,
                                            }))
                                        }
                                        placeholder="Enter price per kg"
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Original Price Per Kg</Label>
                                    <PositiveNumberInput
                                        value={formData.originalPricePerKg}
                                        onChange={(e) =>
                                            setFormData((prev) => ({
                                                ...prev,
                                                originalPricePerKg: e.target.value,
                                            }))
                                        }
                                        placeholder="Enter original price per kg"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        {/* Weights Section */}
                        <FormGroup>
                            <Label>
                                Select Weights (kg) <span className="text-danger">*</span>
                            </Label>

                            {/* Existing weights */}
                            <div className="flex gap-2 flex-wrap mt-2">
                                {formData.weights.map((w, index) => (
                                    <button
                                        key={index}
                                        type="button"
                                        className="px-3 py-1 rounded border bg-[#D95D39] text-white"
                                        onClick={() =>
                                            setFormData((prev) => ({
                                                ...prev,
                                                weights: prev.weights.filter((_, i) => i !== index), // remove by index
                                            }))
                                        }
                                    >
                                        {w.weight}kg (Stock: {w.stock}) ✕
                                    </button>
                                ))}
                            </div>

                            {/* Input to add new weight */}
                            <div className="flex items-center gap-2 mt-3">
                                <PositiveNumberInput
                                    placeholder="Weight (kg)"
                                    className="form-control w-32"
                                    value={formData.newWeight || ""}
                                    onChange={(e) =>
                                        setFormData((prev) => ({ ...prev, newWeight: e.target.value }))
                                    }
                                    step={0.5}
                                />
                                <PositiveNumberInput
                                    placeholder="Stock"
                                    className="form-control w-32"
                                    value={formData.newStock || ""}
                                    onChange={(e) =>
                                        setFormData((prev) => ({ ...prev, newStock: e.target.value }))
                                    }
                                />
                                <Button
                                    type="button"
                                    className="px-3 py-1 rounded bg-[#D95D39] text-white"
                                    onClick={() => {
                                        const newWeightValue = Number(formData.newWeight);
                                        const newStockValue = Number(formData.newStock);

                                        if (!newWeightValue || !newStockValue) return;

                                        // ✅ Check for duplicates
                                        const exists = formData.weights.some(
                                            (w) => w.weight === newWeightValue
                                        );

                                        if (exists) {
                                            alert(`Weight ${newWeightValue}kg already exists!`);
                                            return;
                                        }

                                        // ✅ Add new weight
                                        setFormData((prev) => ({
                                            ...prev,
                                            weights: [
                                                ...prev.weights,
                                                { weight: newWeightValue, stock: newStockValue },
                                            ],
                                            newWeight: "",
                                            newStock: "",
                                        }));
                                    }}
                                >
                              

                                Add
                            </Button>
                        </div>

                        {/* Price preview */}
                        {formData.weights.length > 0 && (
                            <div className="mt-3">
                                <Label className="fw-bold">Price per Weight:</Label>
                                <ul className="list-unstyled mt-1">
                                    {formData.weights.map((w, i) => (
                                        <li key={i}>
                                            {w.weight} kg → Rs.{" "}
                                            {formData.pricePerKg
                                                ? (Number(formData.pricePerKg) * w.weight).toFixed(2)
                                                : "0"}{" "}
                                            (Stock: {w.stock})
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </FormGroup>

            </>
                )}

            {/* ================= Description ================= */}
            <FormGroup>
                <Label>
                    Description <span className="text-danger">*</span>
                </Label>
                <Input
                    type="textarea"
                    rows="4"
                    placeholder="Enter product description"
                    value={formData.description}
                    onChange={(e) =>
                        setFormData((prev) => ({
                            ...prev,
                            description: e.target.value,
                        }))
                    }
                    required
                />
            </FormGroup>

            {/* ================= Product Details ================= */}
            <FormGroup className="mt-4">
                <Row className="align-items-center mb-3">
                    <Col md={6}>
                        <Label className="fw-bold mb-0">
                            Product Details <span className="text-danger">*</span>
                        </Label>
                    </Col>
                    <Col md={6} className="text-end">
                        <Button
                            type="button"
                            className="d-flex align-items-center ms-auto"
                            size="sm"
                            onClick={handleAddDetail}
                        >
                            <FiPlus className="me-1" /> Add Row
                        </Button>
                    </Col>
                </Row>

                {productDetails?.map((detail, index) => (
                    <div key={index} className="flex flex-wrap items-center gap-2 mb-2">
                        {/* Title */}
                        <div className="w-full md:w-5/12">
                            <Input
                                type="text"
                                placeholder="Enter Title"
                                value={detail.key}
                                onChange={(e) => handleChange(index, "key", e.target.value)}
                                required
                            />
                        </div>

                        {/* Value */}
                        <div className="w-full md:w-5/12">
                            <Input
                                type="text"
                                placeholder="Enter Description"
                                value={detail.value}
                                onChange={(e) => handleChange(index, "value", e.target.value)}
                                required
                            />
                        </div>

                        {/* Delete */}
                        <div className="w-full md:w-1/12 flex justify-end">
                            <button
                                type="button"
                                onClick={() => handleDeleteDetail(index)}
                                className="bg-red-500 hover:bg-red-600 text-white text-xs p-1 rounded w-9 h-8 flex items-center justify-center"
                            >
                                <FiTrash size={12} />
                            </button>
                        </div>
                    </div>
                ))}
            </FormGroup>

            {/* ================= Images ================= */}
            <FormGroup>
                <Label>
                    Images <span className="text-danger">*</span>
                </Label>
                <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                    <Input
                       innerRef={fileInputRef} 
                        type="file"
                        name="images"
                        accept="image/*"
                        multiple
                        onChange={handleImageUpload}
                        style={{ opacity: 0, position: 'absolute', width: '100%', height: '100%', cursor: 'pointer' }}
                    />
                    <button 
                        type="button"
                        onClick={() => fileInputRef.current?.click()}
                        className="btn btn-light border"
                        style={{ width: '100%', textAlign: 'left', pointerEvents: 'none' }}
                    >
                        <span>
                            {formData.imagePreview?.length === 1 
                                ? formData.imagePreview?.[0] || 'Choose Files'
                                : formData.imagePreview?.length > 1
                                ? `${formData.imagePreview.length} files selected`
                                : 'Choose Files'}
                        </span>
                    </button>
                </div>

                {formData.imagePreview?.length > 0 && (
                    <div className="mt-4 d-flex flex-wrap gap-2">
                        {formData.imagePreview.map((preview, index) => (
                            
                            <div
                                key={index}
                                style={{
                                    position: "relative",
                                    display: "inline-block",
                                }}
                            >
                                <img
                                    src={
                                        preview.includes("blob:")
                                            ? preview
                                            : getPublicS3Url(preview)
                                    }
                                    alt={`Preview ${index}`}
                                    style={{
                                        maxWidth: "120px",
                                        borderRadius: "8px",
                                        objectFit: "cover",
                                    }}
                                />
                                <button
                                    type="button"
                                    onClick={() => handleRemoveImage(index)}
                                    style={{
                                        position: "absolute",
                                        top: "-6px",
                                        right: "-6px",
                                        background: "red",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "50%",
                                        width: "20px",
                                        height: "20px",
                                        fontSize: "12px",
                                        cursor: "pointer",
                                        lineHeight: "18px",
                                    }}
                                >
                                    ×
                                </button>
                            </div>
                        ))}
                    </div>
                )}
            </FormGroup>



        </Form>
        </Fragment >
    )
}

export default CreateProduct
